<template>
  <v-app>
    <div style="width: 100%; zoom: 0.92; margin: 0 auto; padding: 15px; text-align: left; font-family: 'Times New Roman', Times, serif;">
      <table style="width: 100%;">
        <tr>
          <td v-if="logo!=null" style="width: fit-content; vertical-align: top;"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
          <td></td>
          <td>&nbsp;</td>
          <td style="width: 35%; vertical-align: text-top; align-items: end;">
            <table v-if="ledger!=null" style="width: 100%">
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Ledger</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ ledger.ledgercode }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Start Date</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ new Date(ledger.startdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">End Date</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ new Date(ledger.enddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</span></td>
              </tr>
            </table> 
          </td>
        </tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 5px;"></div>
      <table style="width: 100%; padding-bottom: 10px;">
        <tr>
          <td>
            <div align="center" style="padding: 0; line-height: 0;"><h3><b>Income Statement</b></h3></div>
            <p align="center" style="padding: 0; line-height: 0;">
            Period:
              {{ new Date(ledger.startdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}&nbsp;- 
              {{ new Date(ledger.enddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
            </p>
          </td>
        </tr>
        <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 5px;"></div>
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <tbody v-if="data_revenue.length!=0">
          <tr>
            <th :style="css['row-bottom-left']">REVENUE</th>
            <th v-if="ledger.isDualCurrency==true" :style="css['row-bottom-right']">{{ ledger.secondaryCurrency }}</th>
            <th :style="css['row-bottom-right']">{{ ledger.primaryCurrency }}</th>
          </tr>
        </tbody>
        <tbody v-if="data_revenue.length!=0">
          <tr v-for="(trans) in data_revenue"  v-bind:key="trans._id">
            <td :style="css['row-left']"> {{ trans.accountname }}</td>
            <td v-if="ledger.isDualCurrency==true" :style="css['row-right']">{{ TransAmount2(trans, true) }}</td>
            <td :style="css['row-right']">{{ TransAmount(trans, true) }}</td>
          </tr>
          <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
          <tr>
            <td :style="css['row-top-left']">TOTAL REVENUE&nbsp;</td>
            <td v-if="ledger.isDualCurrency==true" :style="css['row-top-right']">{{ sum_revenue2 }}</td>
            <td :style="css['row-top-right']">{{ sum_revenue }}</td>
          </tr>
        </tbody>
        <tr><td><div style="height: 20px;">&nbsp;</div></td></tr>
        <tbody v-if="data_expense.length!=0">
          <tr>
            <th :style="css['row-bottom-left']">EXPENSE</th>
            <th v-if="ledger.isDualCurrency==true" :style="css['row-bottom-right']"></th>
            <th :style="css['row-bottom-right']"></th>
          </tr>
        </tbody>
        <tbody v-if="data_expense.length!=0">
          <tr v-for="(trans) in data_expense"  v-bind:key="trans._id">
            <td :style="css['row-left']"> {{ trans.accountname }}</td>
            <td v-if="ledger.isDualCurrency==true" :style="css['row-right']">{{ TransAmount2(trans, false) }}</td>
            <td :style="css['row-right']">{{ TransAmount(trans, false) }}</td>
          </tr>
          <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
          <tr>
            <td :style="css['row-top-left']">TOTAL EXPENSE&nbsp;</td>
            <td v-if="ledger.isDualCurrency==true" :style="css['row-top-right']">{{ sum_expense2 }}</td>
            <td :style="css['row-top-right']">{{ sum_expense }}</td>
          </tr>
        </tbody>
        <tr><td><div style="height: 20px;">&nbsp;</div></td></tr>
        <tbody>
          <tr v-if="data_payroll.length!=0">
            <th :style="css['row-bottom-left']">PAYROLL</th>
            <th v-if="ledger.isDualCurrency==true" :style="css['row-bottom-right']"></th>
            <th :style="css['row-bottom-right']"></th>
          </tr>
        </tbody>
        <tbody v-if="data_payroll.length!=0">
          <tr v-for="(trans) in data_payroll"  v-bind:key="trans._id">
            <td :style="css['row-left']">{{ trans.accountname }}</td>
            <td v-if="ledger.isDualCurrency==true" :style="css['row-right']">{{ TransAmount2(trans, false) }}</td>
            <td :style="css['row-right']">{{ TransAmount(trans, false) }}</td>
          </tr>
          <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
          <tr>
            <td :style="css['row-top-left']">TOTAL PAYROLL&nbsp;</td>
            <td v-if="ledger.isDualCurrency==true" :style="css['row-top-right']">{{ sum_payroll2 }}</td>
            <td :style="css['row-top-right']">{{ sum_payroll }}</td>
          </tr>
        </tbody>
        <tr><td><div style="height: 20px;">&nbsp;</div></td></tr>
        <tbody>
          <tr>
            <td :style="css['row-top-left']">OPERATING INCOME&nbsp;</td>
            <td v-if="ledger.isDualCurrency==true" :style="css['row-top-right']">{{ op_income2 }}</td>
            <td :style="css['row-top-right']">{{ op_income }}</td>
          </tr>
        </tbody>
        <tr><td><div style="height: 20px;">&nbsp;</div></td></tr>
        <tbody v-if="data_other.length!=0">
          <tr>
            <th :style="css['row-bottom-left']">OTHER INCOME & EXPENSE</th>
            <th v-if="ledger.isDualCurrency==true" :style="css['row-bottom-right']">{{ ledger.secondaryCurrency }}</th>
            <th :style="css['row-bottom-right']">{{ ledger.primaryCurrency }}</th>
          </tr>
        </tbody>
        <tbody v-if="data_other.length!=0">
          <tr v-for="(trans) in data_other"  v-bind:key="trans._id">
            <td :style="css['row-left']"> {{ trans.accountname }}</td>
            <td v-if="ledger.isDualCurrency==true" :style="css['row-right']">{{ TransAmount2(trans, true) }}</td>
            <td :style="css['row-right']">{{ TransAmount(trans, true) }}</td>
          </tr>
          <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
          <tr>
            <td :style="css['row-top-left']">TOTAL OTHER INCOME & EXPENSE&nbsp;</td>
            <td v-if="ledger.isDualCurrency==true" :style="css['row-top-right']">{{ sum_other2 }}</td>
            <td :style="css['row-top-right']">{{ sum_other }}</td>
          </tr>
        </tbody>
        <tr><td><div style="height: 20px;">&nbsp;</div></td></tr>
        <tbody>
          <tr>
            <td :style="css['row-top-left']">NET INCOME&nbsp;</td>
            <td v-if="ledger.isDualCurrency==true" :style="css['row-top-right']">{{ net_income2 }}</td>
            <td :style="css['row-top-right']">{{ net_income }}</td>
          </tr>
        </tbody>
        <tr><td><div style="height: 20px;">&nbsp;</div></td></tr>
      </table>
      <div style="padding-top: 15px; padding-bottom: 15px;"></div>
    </div>
  </v-app>
</template>
<script>
import {mapActions} from "vuex";
import { getLogo } from '../../util/tools';

export default {
  name: 'PrintBill',
  props: {
    id: String
  },
  data() {
    return {
      decimal1: 0,
      decimal2: 0,
      logo: null,
      initvalue: {},
      ledger: {},
      data_company: {},
      transactions: [],
      css: {
        'row-top-right': 'padding: 2px; text-align: right; border-top: 2px; border-top-style: solid;',
        'row-top-left': 'padding: 2px; text-align: left; border-top: 2px; border-top-style: solid; font-weight: bold;',
        'row-bottom-right': 'padding: 2px; text-align: right; border-bottom: 1px; border-bottom-style: solid;',
        'row-bottom-left': 'padding: 2px; text-align: left; border-bottom: 1px; border-bottom-style: solid;',
        'row-left': 'text-align: left; padding: 2px;',
        'row-right': 'text-align: right; padding: 2px;',
      },
    }
  },
  methods: {
    ...mapActions('PrintApi', ['getGLReportISRequest', 'getCompanyDataRequest']),
    TransAmount(trans, isCredit){
      let result;
      if(isCredit==true) result = trans.creditAmount-trans.debitAmount;
      else result = trans.debitAmount-trans.creditAmount;
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.decimal1, maximumFractionDigits: this.decimal1 });
      return result;
    },
    TransAmount2(trans, isCredit){
      let result;
      if(isCredit==true) result = trans.creditAmount2-trans.debitAmount2;
      else result = trans.debitAmount2-trans.creditAmount2;
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.decimal2, maximumFractionDigits: this.decimal2 });
      return result;
    },
  },
  computed: {
    data_revenue(){
      let result = this.transactions.filter(trans=>trans.accountclass=='Revenue');
      return result;
    },
    data_expense(){
      let result = this.transactions.filter(trans=>trans.accountclass=='Expense');
      return result;
    },
    data_payroll(){
      let result = this.transactions.filter(trans=>trans.accountclass=='Payroll');
      return result;
    },
    data_other(){
      let result = this.transactions.filter(trans=>trans.accountclass=='Other');
      return result;
    },
    sum_revenue(){
      let result = this.transactions.filter(trans=>trans.accountclass=='Revenue');
      result = result.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.decimal1, maximumFractionDigits: this.decimal1 });
      return result;
    },
    sum_revenue2(){
      let result = this.transactions.filter(trans=>trans.accountclass=='Revenue');
      result = result.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.decimal2, maximumFractionDigits: this.decimal2 });
      return result;
    },
    sum_expense(){
      let result = this.transactions.filter(trans=>trans.accountclass=='Expense');
      result = result.reduce((a, b) => a + (b.debitAmount-b.creditAmount), 0);
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.decimal1, maximumFractionDigits: this.decimal1 });
      return result;
    },
    sum_expense2(){
      let result = this.transactions.filter(trans=>trans.accountclass=='Expense');
      result = result.reduce((a, b) => a + (b.debitAmount2-b.creditAmount2), 0);
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.decimal2, maximumFractionDigits: this.decimal2 });
      return result;
    },
    sum_payroll(){
      let result = this.transactions.filter(trans=>trans.accountclass=='Payroll');
      result = result.reduce((a, b) => a + (b.debitAmount-b.creditAmount), 0);
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.decimal1, maximumFractionDigits: this.decimal1 });
      return result;
    },
    sum_payroll2(){
      let result = this.transactions.filter(trans=>trans.accountclass=='Payroll');
      result = result.reduce((a, b) => a + (b.debitAmount2-b.creditAmount2), 0);
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.decimal2, maximumFractionDigits: this.decimal2 });
      return result;
    },
    sum_other(){
      let result = this.transactions.filter(trans=>trans.accountclass=='Other');
      result = result.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.decimal1, maximumFractionDigits: this.decimal1 });
      return result;
    },
    sum_other2(){
      let result = this.transactions.filter(trans=>trans.accountclass=='Other');
      result = result.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.decimal2, maximumFractionDigits: this.decimal2 });
      return result;
    },
    op_income(){
      let revenue = this.transactions.filter(trans=>trans.accountclass=='Revenue');
      let expense = this.transactions.filter(trans=>trans.accountclass=='Expense');
      let payroll = this.transactions.filter(trans=>trans.accountclass=='Payroll');
      let revenue_sum = revenue.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
      let expense_sum = expense.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
      let payroll_sum = payroll.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
      let income = revenue_sum + expense_sum + payroll_sum;
      income = income.toLocaleString("en-US", { minimumFractionDigits: this.decimal1, maximumFractionDigits: this.decimal1 });
      return income;
    },
    op_income2(){
      let revenue = this.transactions.filter(trans=>trans.accountclass=='Revenue');
      let expense = this.transactions.filter(trans=>trans.accountclass=='Expense');
      let payroll = this.transactions.filter(trans=>trans.accountclass=='Payroll');
      let revenue_sum = revenue.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
      let expense_sum = expense.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
      let payroll_sum = payroll.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
      let income = revenue_sum + expense_sum + payroll_sum;
      income = income.toLocaleString("en-US", { minimumFractionDigits: this.decimal2, maximumFractionDigits: this.decimal2 });
      return income;
    },
    net_income(){
      let revenue = this.transactions.filter(trans=>trans.accountclass=='Revenue');
      let expense = this.transactions.filter(trans=>trans.accountclass=='Expense');
      let payroll = this.transactions.filter(trans=>trans.accountclass=='Payroll');
      let other = this.transactions.filter(trans=>trans.accountclass=='Other');
      let revenue_sum = revenue.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
      let expense_sum = expense.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
      let payroll_sum = payroll.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
      let other_sum = other.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
      let income = revenue_sum + expense_sum + payroll_sum + other_sum;
      income = income.toLocaleString("en-US", { minimumFractionDigits: this.decimal1, maximumFractionDigits: this.decimal1 });
      return income;
    },
    net_income2(){
      let revenue = this.transactions.filter(trans=>trans.accountclass=='Revenue');
      let expense = this.transactions.filter(trans=>trans.accountclass=='Expense');
      let payroll = this.transactions.filter(trans=>trans.accountclass=='Payroll');
      let other = this.transactions.filter(trans=>trans.accountclass=='Other');
      let revenue_sum = revenue.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
      let expense_sum = expense.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
      let payroll_sum = payroll.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
      let other_sum = other.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
      let income = revenue_sum + expense_sum + payroll_sum + other_sum;
      income = income.toLocaleString("en-US", { minimumFractionDigits: this.decimal2, maximumFractionDigits: this.decimal2 });
      return income;
    },
  },
  async created() {
    if(this.id){
      this.initvalue = await this.getGLReportISRequest(this.id);
      this.ledger = this.initvalue;
      this.transactions = Object.assign([], this.ledger.transactions);
      if(this.initvalue==null) this.$router.push({ path: '/error' });
      this.logo = getLogo(this.initvalue.companyid);
      this.data_company = await this.getCompanyDataRequest(this.initvalue.companyid);
      this.decimal1 = this.data_company.options!=null ? this.data_company.options.PrimaryDecimalPlaces : 0;
      this.decimal2 = this.data_company.options!=null ? this.data_company.options.SecondaryDecimalPlaces : 0;
      console.log(this.decimal1, this.decimal2)
      console.log(this.data_company)
    }
  },
}

</script>

<style src="./Print.scss" lang="scss"/>
